/**
 * Spot module helpers: P&L formatting, TP suggestions.
 */

export function suggestTpPrices(referencePrice: number): [number, number, number] {
  return [referencePrice * 1.10, referencePrice * 1.25, referencePrice * 1.50];
}

export function formatSignedUsd(value: number): string {
  const sign = value > 0 ? '+' : value < 0 ? '-' : '';
  const abs = Math.abs(value);
  return `${sign}$${abs.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatSignedRub(value: number): string {
  const sign = value > 0 ? '+' : value < 0 ? '-' : '';
  const abs = Math.abs(value);
  return `${sign}${abs.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₽`;
}

export function formatUsdPrice(price: number): string {
  if (!Number.isFinite(price)) return '—';
  if (price >= 1) return `$${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  if (price >= 0.01) return `$${price.toFixed(4)}`;
  return `$${price.toFixed(6)}`;
}

export function formatQty(qty: number): string {
  if (!Number.isFinite(qty)) return '—';
  if (qty >= 1) return qty.toLocaleString('en-US', { maximumFractionDigits: 6 });
  return qty.toFixed(8).replace(/\.?0+$/, '');
}

export function formatUsdc(amount: number): string {
  return `${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDC`;
}

export function formatPct(value: number): string {
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
}
